import { ReactNode } from 'react';

import {
  DialogBackdrop,
  DialogCloseTrigger,
  DialogContent,
  DialogRoot,
} from '../ui/dialog';

type DialogProps = {
  handleClose: () => void;
  content: ReactNode;
  open: boolean;
  scrollBehavior?: 'inside' | 'outside';
};

export const Dialog = ({
  handleClose,
  content,
  open,
  scrollBehavior,
}: DialogProps) => {
  return (
    <DialogRoot open={open} scrollBehavior={scrollBehavior} size="xl">
      <DialogBackdrop />
      <DialogContent mx={4}>
        {content}
        <DialogCloseTrigger onClick={handleClose} />
      </DialogContent>
    </DialogRoot>
  );
};
